import { Group } from "@mantine/core"
import { AgencyOperationsAdminVenueBookingTabs } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingTabs"
import { EditAgencyOperationsAdminVenueBookingAction } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { formatDate, formatTime } from "src/utils/dates"
import { AgencyOperationsAdminVenueBookingView } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingView"

export function AgencyOperationsAdminVenueBooking() {

    const { currentItem } = useAppState(state=>state.bookings)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.talent?.alias} ${formatDate(currentItem?.date)} ${!!currentItem?.set_start_time ? '@ ': ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminVenueBookingAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminVenueBookingTabs/>
            <AgencyOperationsAdminVenueBookingView/>
        </PageLayout>
    )

}